var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 63.52 62.27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.52,33C62.78,44,57,54.25,44.2,59.72c-11.9,5.09-26.53,2.36-35.58-6.46C-7.21,37.84-.17,9.69,21.06,3.33c1.64-.49,3-1.81,4.57-2.61A4.37,4.37,0,0,1,28.2,0c8,1.7,16,3.39,22.91,8C59.41,13.51,63.63,21.13,63.52,33Zm-59.2-.6c.18,1.64.25,3.3.58,4.91,2.38,11.6,11.23,19.2,23.94,20.62,11.7,1.3,23.37-5.28,28-15.81C63.34,27.49,58.38,14.86,43.54,9c-4.57-1.82-9.49-2.76-14.27-4a5.63,5.63,0,0,0-2.45,0C14,7.44,4.4,19.2,4.32,32.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.45,17.73c-2,5.53-7.6,8.2-11,13.53,3.29,3.16,6.87,6.38,10.13,9.88.86.93.77,2.74,1.11,4.14-1.38-.41-3.06-.45-4.07-1.3-3.61-3-7-6.35-10.77-9.86-3,3-6.24,6.6-9.77,9.88-.87.81-3.09,1.45-3.77.94-2-1.47-.23-2.8.87-4l9.91-10.81L18.34,18l1.21-1.18c5.43,2.26,8.32,7.81,13.13,11L45.39,16.63Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.10f8198ebda2f2dcde4387c06510fa88.svg";
export { ForwardRef as ReactComponent };